var Sticky = function () {

    var setSticky = function ($el) {
        var id = $el.data('sticky-id');
        var stickyOffset = $el.data('sticky-offset');
        var stickyHeight = $el.outerHeight();
        
        var $wrap = $('[data-sticky-wrap="' + id + '"]');
        var wrapTop = $wrap.offset().top;
        var wrapBottom = wrapTop + $wrap.outerHeight();

        $(window).scroll(function(){
            var scrollTop = $(window).scrollTop();
            var setTop = scrollTop - wrapTop + stickyOffset;
            
            if ((setTop + stickyHeight) > (wrapBottom - wrapTop)) {
                $el.css({
                    top: (wrapBottom - wrapTop - stickyHeight)
                });
            }else if (scrollTop >= (wrapTop - stickyOffset) ) {
                $el.css({
                    position: 'relative',
                    top: setTop,
                    transition: '.3s'
                });
            } else {
                $el.css({
                    top: 0
                });
            }
        });
        
    };
    
    var findSticky = function () {
        $('.js-sticky:visible').each(function(){
            setSticky($(this))
        });
    };

    var init = function () {
        findSticky();
    };

    return {
        init: init
    };
}();

UL.register(Sticky);

var SkyscraperWatcher = function() {
    var fix = function () {
        var headerEl = $('.o-header__container');
        var footerEl = $('.o-footer');
        var skyscraperEl = $('.ad-right_skyscraper');
        var prevEl = $('.ad-right_skyscraper').prev();
        var offset = 30;
        var boundingTop = prevEl.offset().top + prevEl.height() - headerEl.height() - offset;
        var boundingBottom = footerEl.offset().top - skyscraperEl.height() - offset * 2 - headerEl.height();

        var scrollTop = $(window).scrollTop();

        if (scrollTop >= boundingTop && scrollTop < boundingBottom) {
            skyscraperEl.css('transform', 'translateY(' + (scrollTop - boundingTop) + 'px)');
        }
    }

    return {
        init: function() {
            if ($('.ad-right_skyscraper').length) {
                setTimeout(function() {
                    $(window).on('scroll', fix);

                    fix();
                }, 300);
            }
        }
    };
}();

UL.register(SkyscraperWatcher);

